// ============================================================================
// i18n CONFIGURATION - Internationalization Setup
// ============================================================================

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enAssessment from './locales/en/assessment.json';
import enResults from './locales/en/results.json';
import enActionPlan from './locales/en/actionPlan.json';

import arCommon from './locales/ar/common.json';
import arAssessment from './locales/ar/assessment.json';
import arResults from './locales/ar/results.json';
import arActionPlan from './locales/ar/actionPlan.json';

import esCommon from './locales/es/common.json';
import esAssessment from './locales/es/assessment.json';
import esResults from './locales/es/results.json';
import esActionPlan from './locales/es/actionPlan.json';

import frCommon from './locales/fr/common.json';
import frAssessment from './locales/fr/assessment.json';
import frResults from './locales/fr/results.json';
import frActionPlan from './locales/fr/actionPlan.json';

import deCommon from './locales/de/common.json';
import deAssessment from './locales/de/assessment.json';
import deResults from './locales/de/results.json';
import deActionPlan from './locales/de/actionPlan.json';

// ============================================================================
// LANGUAGE CONFIGURATION
// ============================================================================

export const LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', dir: 'ltr' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
];

export const RTL_LANGUAGES = ['ar', 'he', 'ur', 'fa'];

export const isRTL = (langCode) => RTL_LANGUAGES.includes(langCode);

// ============================================================================
// RESOURCES
// ============================================================================

const resources = {
  en: {
    common: enCommon,
    assessment: enAssessment,
    results: enResults,
    actionPlan: enActionPlan,
  },
  ar: {
    common: arCommon,
    assessment: arAssessment,
    results: arResults,
    actionPlan: arActionPlan,
  },
  es: {
    common: esCommon,
    assessment: esAssessment,
    results: esResults,
    actionPlan: esActionPlan,
  },
  fr: {
    common: frCommon,
    assessment: frAssessment,
    results: frResults,
    actionPlan: frActionPlan,
  },
  de: {
    common: deCommon,
    assessment: deAssessment,
    results: deResults,
    actionPlan: deActionPlan,
  },
};

// ============================================================================
// INITIALIZE i18n
// ============================================================================

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'assessment', 'results', 'actionPlan'],
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'lab2040_language',
    },
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    react: {
      useSuspense: false,
    },
  });

export default i18n;
